import * as Sentry from '@sentry/react';
import {type UpdateIvIntentPayload, type CoreError, type IVIntent} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';
import {useMutation} from '@tanstack/react-query';

type Props = {
  postHandler?: () => void;
  onSuccess?: (data: IVIntent) => void;
};
export const useUpdateIvIntent = ({onSuccess, postHandler}: Props = {}) => {
  const {updateIvIntent} = useChekinSDK();
  const {
    mutate: sendUpdateIvIntentRequest,
    mutateAsync: sendUpdateIvIntentRequestAsync,
    isLoading,
  } = useMutation<IVIntent, CoreError, UpdateIvIntentPayload>(updateIvIntent, {
    onError: error => {
      Sentry.captureException(error);
    },
    onSuccess: data => {
      onSuccess?.(data);
    },
    onSettled: postHandler,
  });

  return {
    isLoading,
    sendUpdateIvIntentRequest,
    sendUpdateIvIntentRequestAsync,
  };
};
